import { render, staticRenderFns } from "./NofileFound.vue?vue&type=template&id=aa23d3c6&"
import script from "./NofileFound.vue?vue&type=script&lang=js&"
export * from "./NofileFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports